import React from "react";

import connect from "../i18n/connect";
import { canAccessPaymentInvoices } from "../lib/payment/canAccessPaymentInvoices";
import { getUserData } from "../redux/modules/auth/login/selector";
import {
  fetchPaymentInvoicesRoutine,
  PAYMENT_INVOICES_DEFAULT_LIMIT
} from "../redux/modules/paymentInvoices";
import { getPaymentInvoicesState } from "../redux/modules/paymentInvoices/selector";

export default function withPaymentInvoices(WrappedComponent) {
  const mapStateToProps = state => ({
    paymentInvoices: getPaymentInvoicesState(state),
    userData: getUserData(state)
  });

  const mapDispatchToProps = {
    fetchPaymentInvoices: fetchPaymentInvoicesRoutine
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithPaymentInvoices extends React.Component {
    componentDidMount() {
      this.fetchInvoicesIfAllowed(this.props.userData);
    }

    componentDidUpdate(prevProps) {
      if (
        !canAccessPaymentInvoices(prevProps.userData) &&
        canAccessPaymentInvoices(this.props.userData)
      ) {
        this.fetchInvoicesIfAllowed(this.props.userData);
      }
    }

    fetchInvoicesIfAllowed(userData) {
      if (!canAccessPaymentInvoices(userData)) {
        return;
      }

      this.props.fetchPaymentInvoices({
        offset: 0,
        limit: PAYMENT_INVOICES_DEFAULT_LIMIT
      });
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithPaymentInvoices;
}
